import { t } from 'i18next'
import { DateTime } from 'luxon'

import { Contract, ContractTenant } from '../../../../../common/validations'
import { ContractStatus } from '../../../../../common/types'
import { formatDate } from '../../../../utils/dateUtils'

const isTenantPartEndedBeforeContractEnd = (
  contractEndDate: string | null | undefined,
  tenantTerminationDate: string
) => {
  if (!contractEndDate) return true
  return (
    DateTime.fromISO(tenantTerminationDate) < DateTime.fromISO(contractEndDate)
  )
}

export const resolveTenantStatusLabel = (
  contract: Contract,
  tenant: ContractTenant,
  showPendingState: boolean
) => {
  if (
    tenant.tenantTerminationDate &&
    (!contract.isFixedTerm ||
      isTenantPartEndedBeforeContractEnd(
        contract.endDate,
        tenant.tenantTerminationDate
      ) ||
      contract.status === ContractStatus.TERMINATED)
  ) {
    return t('contractModification:terminationDisallowedReasons.endsOn', {
      date: formatDate(tenant.tenantTerminationDate),
    })
  }

  if (showPendingState) {
    return t('contractModification:terminationDisallowedReasons.pending')
  }

  return undefined
}
